/*
 *
 * SignupParent actions
 *
 */

import {
  FLUSH_STATE_SIGNUPPARENT,
  LOAD_SIGNUPPARENT,
  LOAD_SIGNUPPARENT_SUCCESS,
  LOAD_SIGNUPPARENT_ERROR,
  CHANGE_SIGNUPPARENT,
  CHANGE_SIGNUPPARENT_SUCCESS,
  CHANGE_SIGNUPPARENT_ERROR,
  DELETE_SIGNUPPARENT,
  DELETE_SIGNUPPARENT_SUCCESS,
  DELETE_SIGNUPPARENT_ERROR,
} from './constants';

/**
 * Clearing the state for SignupParent
 */
export function flushStateSignupParent() {
  return {
    type: FLUSH_STATE_SIGNUPPARENT,
  };
}

/**
 * ------------------ LOAD ------------------
 */

/**
 * Load the SignupParent, this action starts the request saga
 *
 * @return {array} An action object with a type of LOAD_SIGNUPPARENT
 */
export function loadSignupParent() {
  return {
    type: LOAD_SIGNUPPARENT,
  };
}

/**
 * Dispatched when the loadSignupParent are loaded by the request saga
 *
 * @param  {array} variables true for SignupParent
 *
 * @return {array} An action object with a type of LOAD_SIGNUPPARENT_SUCCESS passing the variables
 */
export function loadSignupParentSuccess(signupParentList) {
  return {
    type: LOAD_SIGNUPPARENT_SUCCESS,
    signupParentList,
  };
}

/**
 * Dispatched when loading the loadSignupParent fails
 *
 * @param  {object} error The error
 *
 * @return {object} An action object with a type of LOAD_SIGNUPPARENT_ERROR passing the error
 */
export function loadSignupParentError(error) {
  return {
    type: LOAD_SIGNUPPARENT_ERROR,
    error,
  };
}

/**
 * ------------------ CHANGE ------------------
 */

/**
 * Change/Update the SignupParent, this action starts the request saga
 *
 * @return {array} An action object with a type of CHANGE_SIGNUPPARENT
 */
export function changeSignupParent(signupParentData) {
  return {
    type: CHANGE_SIGNUPPARENT,
    signupParentData,
  };
}

/**
 * Dispatched when the changeSignupParent are changed/updated by the request saga
 *
 * @param  {array} variables true for SignupParent
 *
 * @return {array} An action object with a type of CHANGE_SIGNUPPARENT_SUCCESS passing the variables
 */
export function changeSignupParentSuccess(signupParentData) {
  return {
    type: CHANGE_SIGNUPPARENT_SUCCESS,
    signupParentData,
  };
}

/**
 * Dispatched when loading the changeSignupParent fails
 *
 * @param  {object} error The error
 *
 * @return {object} An action object with a type of CHANGE_SIGNUPPARENT_ERROR passing the error
 */
export function changeSignupParentError(error) {
  return {
    type: CHANGE_SIGNUPPARENT_ERROR,
    error,
  };
}

/**
 * ------------------ DELETE ------------------
 */

/**
 * Delete the SignupParent, this action starts the request saga
 *
 * @return {object} An action object with a type of DELETE_SIGNUPPARENT
 */
export function deleteSignupParent(id) {
  return {
    type: DELETE_SIGNUPPARENT,
    id,
  };
}

/**
 * Dispatched when the deleteSignupParent are deleted by the request saga
 *
 * @param  {object} variables true for SignupParent
 *
 * @return {object} An action object with a type of DELETE_SIGNUPPARENT_SUCCESS passing the variables
 */
export function deleteSignupParentSuccess() {
  return {
    type: DELETE_SIGNUPPARENT_SUCCESS,
  };
}

/**
 * Dispatched when loading the deleteSignupParent fails
 *
 * @param  {object} error The error
 *
 * @return {object} An action object with a type of DELETE_SIGNUPPARENT_ERROR passing the error
 */
export function deleteSignupParentError(error) {
  return {
    type: DELETE_SIGNUPPARENT_ERROR,
    error,
  };
}
